import React, { useState } from 'react';

const CashRegisterView = ({ currentUser, patients = [], invoices = [], cashTransactions = [], onRecordCashTransaction }) => {
    const [transaction, setTransaction] = useState({ type: 'payment', amount: '', patientId: '', invoiceId: '', paymentMethod: 'Especes', insurance: '', validationType: 'signature', signature: '', notes: '' });

    const handleChange = (field, value) => setTransaction(prev => ({ ...prev, [field]: value }));

    const submit = (e) => {
        e.preventDefault();
        if (!transaction.amount || Number(transaction.amount) <= 0) {
            alert('Veuillez saisir un montant valide.');
            return;
        }
        if (!transaction.signature) {
            alert('La signature est requise pour valider l’opération.');
            return;
        }
        onRecordCashTransaction(transaction);
        setTransaction({ type: 'payment', amount: '', patientId: '', invoiceId: '', paymentMethod: 'Especes', insurance: '', validationType: 'signature', signature: '', notes: '' });
    };

    const patientOptions = patients.map(p => (
        <option key={p.id} value={p.id}>{p.code ? `${p.code} • ${p.prenom} ${p.name}` : `${p.prenom} ${p.name}`}</option>
    ));

    return (
        <div style={{ padding: '24px' }}>
            <h2>Module Caisse</h2>
            <p>Utilisateur : <strong>{currentUser?.name}</strong> ({currentUser?.role})</p>

            <section style={{ marginBottom: '24px', padding: '20px', borderRadius: '16px', backgroundColor: '#f8fafc', border: '1px solid #dbeafe' }}>
                <h3>Mouvement de caisse</h3>
                <form onSubmit={submit} style={{ display: 'grid', gap: '14px' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '14px' }}>
                        <label>
                            Type
                            <select value={transaction.type} onChange={(e) => handleChange('type', e.target.value)} style={{ width: '100%', padding: '10px', marginTop: '8px' }}>
                                <option value="payment">Entrée paiement</option>
                                <option value="refund">Sortie remboursement</option>
                            </select>
                        </label>
                        <label>
                            Montant
                            <input type="number" value={transaction.amount} onChange={(e) => handleChange('amount', e.target.value)} placeholder="Montant" style={{ width: '100%', padding: '10px', marginTop: '8px' }} />
                        </label>
                        <label>
                            Patient assuré
                            <select value={transaction.patientId} onChange={(e) => handleChange('patientId', e.target.value)} style={{ width: '100%', padding: '10px', marginTop: '8px' }}>
                                <option value="">Aucun patient</option>
                                {patientOptions}
                            </select>
                        </label>
                        <label>
                            Facture
                            <select value={transaction.invoiceId} onChange={(e) => handleChange('invoiceId', e.target.value)} style={{ width: '100%', padding: '10px', marginTop: '8px' }}>
                                <option value="">Aucune facture</option>
                                {invoices.filter(invoice => invoice.status !== 'paid').map(invoice => (
                                    <option key={invoice.id} value={invoice.id}>#{invoice.id} - {Number(invoice.total || 0).toFixed(2)} {invoice.currency || 'USD'}</option>
                                ))}
                            </select>
                        </label>
                        <label>
                            Mode de paiement
                            <select value={transaction.paymentMethod} onChange={(e) => handleChange('paymentMethod', e.target.value)} style={{ width: '100%', padding: '10px', marginTop: '8px' }}>
                                <option>Especes</option>
                                <option>MonCash</option>
                                <option>NatCash</option>
                                <option>Carte / Stripe</option>
                                <option>PayPal</option>
                                <option>Wise</option>
                                <option>Meru</option>
                                <option>Virement</option>
                                <option>Assurance</option>
                            </select>
                        </label>
                        <label>
                            Assurance / prise en charge
                            <input type="text" value={transaction.insurance} onChange={(e) => handleChange('insurance', e.target.value)} placeholder="Nom de l'assurance ou aucune" style={{ width: '100%', padding: '10px', marginTop: '8px' }} />
                        </label>
                    </div>
                    <label>
                        Notes
                        <textarea value={transaction.notes} onChange={(e) => handleChange('notes', e.target.value)} placeholder="Raison de l'opération" style={{ width: '100%', padding: '10px', marginTop: '8px' }} rows={3} />
                    </label>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                        <div style={{ width: 'min(100%, 360px)', padding: '12px', border: '1px solid #cbd5e1', borderRadius: '10px', backgroundColor: '#ffffff' }}>
                            <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: 600 }}>
                                Validation
                                <select value={transaction.validationType} onChange={(e) => handleChange('validationType', e.target.value)} style={{ width: '100%', padding: '8px', marginTop: '6px' }}>
                                    <option value="signature">Signature manuscrite</option>
                                    <option value="fingerprint">Empreinte confirmée par appareil</option>
                                </select>
                            </label>
                            <label style={{ display: 'block', marginTop: '8px', fontSize: '0.9rem', fontWeight: 600 }}>
                                Référence de validation
                                <input type="text" value={transaction.signature} onChange={(e) => handleChange('signature', e.target.value)} placeholder="Nom signé ou référence appareil" style={{ width: '100%', padding: '8px', marginTop: '6px' }} />
                            </label>
                            <small style={{ display: 'block', marginTop: '6px', color: '#64748b' }}>Aucune empreinte biométrique brute n'est enregistrée dans l'application.</small>
                        </div>
                    </div>
                    <button type="submit" style={{ width: 'fit-content', padding: '12px 18px', borderRadius: '10px', backgroundColor: '#0d3b66', border: 'none', color: 'white', cursor: 'pointer' }}>Valider la transaction</button>
                </form>
            </section>

            <section style={{ padding: '20px', borderRadius: '16px', backgroundColor: '#ffffff', border: '1px solid #e2e8f0' }}>
                <h3>Dernières transactions caisse</h3>
                {cashTransactions.length > 0 ? (
                    <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'grid', gap: '12px' }}>
                        {cashTransactions.slice(0, 8).map(tx => (
                            <li key={tx.id} style={{ padding: '14px', borderRadius: '12px', border: '1px solid #cbd5e1', backgroundColor: '#f8fafc' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px', flexWrap: 'wrap' }}>
                                    <span><strong>{tx.type === 'payment' ? 'Entrée' : 'Sortie'}</strong> - {Number(tx.amount || 0).toFixed(2)} USD · Reçu {tx.receiptCode || '—'}</span>
                                    <span>{tx.date}</span>
                                </div>
                                <p style={{ margin: '8px 0 0' }}>Patient : {tx.patientCode || 'N/A'}</p>
                                <p style={{ margin: '4px 0 0' }}>Signature : {tx.signature || '—'}</p>
                                {tx.notes && <p style={{ margin: '4px 0 0' }}>Notes : {tx.notes}</p>}
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>Aucune transaction enregistrée.</p>
                )}
            </section>
        </div>
    );
};

export default CashRegisterView;
